import React from 'react';

type IContext = {
  ongoingRequests: Map<string, boolean>;
  addRequest: (key: string) => void;
  removeRequest: (key: string) => void;
  cacheResponse: (key: string, response: any) => void;
  getCachedResponse: (key: string) => any;
  isRequesting: boolean;
};

export const TrackingRequestContext = React.createContext<IContext>({
  isRequesting: false,
  ongoingRequests: new Map(),
  addRequest: () => {},
  removeRequest: () => {},
  cacheResponse: () => {},
  getCachedResponse: () => {}
});

export const TrackingRequestProvider = ({ children }) => {
  const [ongoingRequests, setOngoingRequests] = React.useState(new Map());
  const [cachedResponses, setCachedResponses] = React.useState(new Map());

  const addRequest = (key) => {
    setOngoingRequests((prev) => new Map(prev).set(key, true));
  };

  const removeRequest = (key) => {
    setOngoingRequests((prev) => {
      const newMap = new Map(prev);
      newMap.delete(key);
      return newMap;
    });
  };

  const cacheResponse = (key, response) => {
    setCachedResponses((prev) => new Map(prev).set(key, response));
  };

  const getCachedResponse = (key) => {
    return cachedResponses.get(key);
  };

  return (
    <TrackingRequestContext.Provider
      value={{
        ongoingRequests,
        addRequest,
        removeRequest,
        cacheResponse,
        getCachedResponse,
        isRequesting: ongoingRequests.size > 0
      }}
    >
      {children}
    </TrackingRequestContext.Provider>
  );
};
